import { projectManagementApi } from '@/includes/projectManagementApi';

const pmTbiService = {
  async getProjectTbi(projectId, {
    weeks = 8,
    months = 4,
    period = 'week',
  } = {}) {
    const response = await projectManagementApi.get(`/projects/${projectId}/kpis/tbi`, {
      params: { weeks, months, period },
    });
    return response.data;
  },
};

export default pmTbiService;
